<template>
  <td :class="[`cell-value-${col}`]">
    <template v-if="entry[col] && entry[col].length > 0">
      <div v-for="(domain, domainindex) in entry[col]" :key="domainindex">
        <small><a :href="addProtocolIfMissing(domain)" target="_blank">{{ domain }}</a></small>
      </div>
    </template>
  </td>
</template>

<script>
export default {
  props: {
    entry: Object,
    col: String,
    editName: String,
    flags: Array,
  },
  methods: {
    addProtocolIfMissing(input) {
      if (!input.match(/^[a-zA-Z]+:\/\//)) {
        return `http://${input}`;
      }
      return input;
    },
  },
};
</script>
